import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue';
// GeneralViews
const NotFound = () => import('../components/GeneralViews/NotFoundPage.vue');
// Dashboard pages
const Overview = () => import('src/components/Dashboard/Views/Dashboard/Overview.vue');
// import Stats from 'src/components/Dashboard/Views/Dashboard/Stats.vue';

// Pages
// import User from 'src/components/Dashboard/Views/Pages/UserProfile.vue';
// import TimeLine from 'src/components/Dashboard/Views/Pages/TimeLinePage.vue';
const Login = () => import('src/components/Dashboard/Views/Pages/Login.vue');
// import Register from 'src/components/Dashboard/Views/Pages/Register.vue';
// import Lock from 'src/components/Dashboard/Views/Pages/Lock.vue';

// Components pages
// import Buttons from 'src/components/Dashboard/Views/Components/Buttons.vue';
// import GridSystem from 'src/components/Dashboard/Views/Components/GridSystem.vue';
// import Panels from 'src/components/Dashboard/Views/Components/Panels.vue';
// import SweetAlert from 'src/components/Dashboard/Views/Components/SweetAlert.vue';
// import Notifications from 'src/components/Dashboard/Views/Components/Notifications.vue';
// import Icons from 'src/components/Dashboard/Views/Components/Icons.vue';
// import Typography from 'src/components/Dashboard/Views/Components/Typography.vue';

// Forms pages
// import RegularForms from 'src/components/Dashboard/Views/Forms/RegularForms.vue';
// import ExtendedForms from 'src/components/Dashboard/Views/Forms/ExtendedForms.vue';
// import ValidationForms from 'src/components/Dashboard/Views/Forms/ValidationForms.vue';
// import Wizard from 'src/components/Dashboard/Views/Forms/Wizard.vue';

// TableList pages
// import RegularTables from 'src/components/Dashboard/Views/Tables/RegularTables.vue';
// import ExtendedTables from 'src/components/Dashboard/Views/Tables/ExtendedTables.vue';
// import PaginatedTables from 'src/components/Dashboard/Views/Tables/PaginatedTables.vue';
// Maps pages
// import GoogleMaps from 'src/components/Dashboard/Views/Maps/GoogleMaps.vue';
// import FullScreenMap from 'src/components/Dashboard/Views/Maps/FullScreenMap.vue';
// import VectorMaps from 'src/components/Dashboard/Views/Maps/VectorMapsPage.vue';

// Calendar
// import Calendar from 'src/components/Dashboard/Views/Calendar/CalendarRoute.vue';
// Charts
// import Charts from 'src/components/Dashboard/Views/Charts.vue';
// schema
const SchemaBaseTable = () => import('src/components/Dashboard/Views/Tables/SchemaBaseTable.vue');
const SchemaBaseForm = () => import('src/components/Dashboard/Views/Forms/SchemaBaseForm.vue');
const Member = () => import('src/schemas/membership');
const MemberAdmin = () => import('src/schemas/membership-admin');
const CreateMember = () => import('src/schemas/membership-create');
const ImportMember = () => import('src/schemas/membership-import');
const Caregiver = () => import('src/schemas/caregiver');
const Client = () => import('src/schemas/client');
const Subprofile = () => import('src/schemas/subprofile');
const CreateSubprofile = () => import('src/schemas/subprofile-create');
const Group = () => import('src/schemas/group');
const GroupApply = () => import('src/schemas/group-apply');
const GroupCreate = () => import('src/schemas/group-create');
const GroupApps = () => import('src/schemas/group-application');
const GroupAppMember = () => import('src/schemas/group-application-member');
const Order = () => import('src/schemas/order');
const CreateOrder = () => import('src/schemas/order-create');
const Transaction = () => import('src/schemas/transaction');
const StandaloneTransaction = () => import('src/schemas/transaction-standalone');
const Payment = () => import('src/schemas/payment');
const Product = () => import('src/schemas/product');
const CreateProduct = () => import('src/schemas/product-create');
const Service = () => import('src/schemas/service');
const Coupon = () => import('src/schemas/coupon');
const CreateCoupon = () => import('src/schemas/coupon-create');
const Appointment = () => import('src/schemas/appointment');
const CreateAppointment = () => import('src/schemas/appointment-create');
const FeedbackAdminToCaregiver = () => import('src/schemas/feedback-admin-to-caregiver');
const FeedbackAdminToClient = () => import('src/schemas/feedback-admin-to-client');
const CreateFeedbackAdmin = () => import('src/schemas/feedback-admin-create');
const FeedbackCaregiver = () => import('src/schemas/feedback-caregiver');
const FeedbackClient = () => import('src/schemas/feedback-client');
const Content = () => import('src/schemas/content');
const ContentAny = () => import('src/schemas/content-any');
const CreateContent = () => import('src/schemas/content-create');
const Enquiry = () => import('src/schemas/enquiry');
const EnquiryQuestionnaire = () => import('src/schemas/enquiry-questionnaire');
const EnquiryQuestionnaire1 = () => import('src/schemas/enquiry-questionnaire1');
const ContentJoinusInputform = () => import('src/schemas/content-joinus-input_form');
// const ContentAreaContent = () => import('src/schemas/content-area-content');
// const ContentPurchaseLatestbooking = () => import('src/schemas/content-purchase-latest_booking');
// const ContentPurchaseNeworder = () => import('src/schemas/content-purchase-new_order');
const ContentJoinusBannertop = () => import('src/schemas/content-joinus-banner_top');
const ContentOurservicespageWhyusfeatures = () => import('src/schemas/content-our_services_page-whyus_features');
// const ContentOurservicespageOverlabel = () => import('src/schemas/content-our_services_page-overlabel');
// const ContentOurservicespageBannerbottom = () => import('src/schemas/content-our_services_page-banner_bottom');
const ContentOurservicespageDownloadtop = () => import('src/schemas/content-our_services_page-download_top');
const ContentOurservicespageWhyusmiddle = () => import('src/schemas/content-our_services_page-whyus_middle');
const ContentOurservicespageOurservicesdetails = () => import('src/schemas/content-our_services_page-our_services_details');
// const ContentAboutus = () => import('src/schemas/content-aboutus');
const ContentAboutusPlaintext = () => import('src/schemas/content-aboutus-plain_text');
const ContentAboutusBridge = () => import('src/schemas/content-aboutus-bridge');
const ContentAboutusMiddle = () => import('src/schemas/content-aboutus-middle');
const ContentAboutusTri = () => import('src/schemas/content-aboutus-tri');
const ContentContentFaq = () => import('src/schemas/content-content-faq');
const ContentRecruitment = () => import('src/schemas/content-recruitment');
const ContentCategory = () => import('src/schemas/content-category');
const ContentPost = () => import('src/schemas/content-post');
const CreateContentPost = () => import('src/schemas/content-post-create');
// const ContentContactMiddle = () => import('src/schemas/content-contact-middle');
const Notification = () => import('src/schemas/notification');
const SystemNotification = () => import('src/schemas/notification-system');
const AdminSendouts = () => import('src/schemas/notification-sendout');
const Emails = () => import('src/schemas/notification-email');
const CreateSystemNotification = () => import('src/schemas/notification-system-create');
const CreateMemberNotification = () => import('src/schemas/notification-member-create');
const Systemconfig = () => import('src/schemas/systemconfig');
const Log = () => import('src/schemas/log');

import {set} from 'lodash';
import debug from 'src/debug';

let parseFilter = q => {
  let obj = {};
  for (let key in q) {
    try {
      set(obj, key, JSON.parse(q[key]));
    } catch (e) {
      set(obj, key, q[key]);
    }
  }
  return obj.filter;
};

let adminMenu = {
  path: '/admin',
  component: DashboardLayout,
  meta: {auth: true},
  children: [
    {
      path: 'members',
      name: 'schema.members',
      component: SchemaBaseTable,
      props: r => ({schema: Member, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'members/create',
      name: ['create_schema_$name', {name: '${i18n.schema.member}'}],
      component: SchemaBaseForm,
      props: {schema: CreateMember},
    },
    {
      path: 'members/import',
      name: 'Import ${i18n.schema.members}',
      component: SchemaBaseForm,
      props: {schema: ImportMember},
    },
    {
      path: 'admins',
      name: 'schema.admins',
      component: SchemaBaseTable,
      props: r => ({schema: MemberAdmin, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'caregivers',
      name: 'schema.caregivers',
      component: SchemaBaseTable,
      props: r => ({schema: Caregiver, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'clients',
      name: 'schema.clients',
      component: SchemaBaseTable,
      props: r => ({schema: Client, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'members/:id',
      name: ['schema_$name_details', {name: '${i18n.schema.member}'}],
      component: SchemaBaseForm,
      props: r => ({schema: Member, id: r.params.id}),
    },
    {
      path: 'subprofiles',
      name: 'schema.subprofiles',
      component: SchemaBaseTable,
      props: r => ({schema: Subprofile}),
    },
    {
      path: 'subprofiles/create',
      name: ['create_schema_$name', {name: '${i18n.schema.subprofile}'}],
      component: SchemaBaseForm,
      props: {schema: CreateSubprofile},
    },
    {
      path: 'subprofiles/:id',
      name: ['schema_$name_details', {name: '${i18n.schema.subprofiles}'}],
      component: SchemaBaseForm,
      props: r => ({schema: Subprofile, id: r.params.id}),
    },
    {
      path: 'groups',
      name: 'schema.groups',
      component: SchemaBaseTable,
      props: r => ({schema: Group, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'groups/apply',
      name: 'schema.group_apply',
      component: SchemaBaseForm,
      props: {schema: GroupApply},
    },
    {
      path: 'groups/create',
      name: ['create_schema_$name', {name: '${i18n.schema.group}'}],
      component: SchemaBaseForm,
      props: {schema: GroupCreate},
    },
    {
      path: 'groups/:id',
      name: ['schema_$name_details', {name: '${i18n.schema.groups}'}],
      component: SchemaBaseForm,
      props: r => ({schema: Group, id: r.params.id}),
    },
    {
      path: 'group-applications',
      name: 'schema.group_applications',
      component: SchemaBaseTable,
      props: r => ({schema: GroupApps, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'group-applications/:id/',
      name: ['schema_$name_details', {name: '${i18n.schema.group_application}'}],
      component: SchemaBaseForm,
      props: r => ({schema: GroupAppMember, id: r.params.id}),
    },
    {
      path: 'appointments',
      name: 'schema.appointments',
      component: SchemaBaseTable,
      props: r => ({schema: Appointment, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'appointments/create',
      name: ['create_schema_$name', {name: '${i18n.schema.appointment}'}],
      component: SchemaBaseForm,
      props: r => ({schema: CreateAppointment, id: r.params.id}),
    },
    {
      path: 'appointments/:id',
      name: ['schema_$name_details', {name: '${i18n.schema.appointment}'}],
      component: SchemaBaseForm,
      props: r => ({schema: Appointment, id: r.params.id}),
    },
    {
      path: 'orders',
      name: 'schema.orders',
      component: SchemaBaseTable,
      props: r => ({schema: Order, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'orders/create',
      name: ['create_schema_$name', {name: '${i18n.schema.order}'}],
      component: SchemaBaseForm,
      props: {schema: CreateOrder},
    },
    {
      path: 'orders/:id',
      name: ['schema_$name_details', {name: '${i18n.schema.order}'}],
      component: SchemaBaseForm,
      props: r => ({schema: Order, id: r.params.id}),
    },
    {
      path: 'transactions',
      name: 'schema.transactions',
      component: SchemaBaseTable,
      props: r => ({schema: Transaction, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'transactions/standalone',
      name: ['create_schema_$name', {name: '${i18n.schema.standalone_transaction}'}],
      component: SchemaBaseForm,
      props: {schema: StandaloneTransaction},
    },
    {
      path: 'transactions/:id',
      name: ['schema_$name_details', {name: '${i18n.schema.transaction}'}],
      component: SchemaBaseForm,
      props: r => ({schema: Transaction, id: r.params.id}),
    },
    {
      path: 'payments',
      name: 'schema.payments',
      component: SchemaBaseTable,
      props: r => ({schema: Payment, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'payments/:id',
      name: ['schema_$name_details', {name: '${i18n.schema.payment}'}],
      component: SchemaBaseForm,
      props: r => ({schema: Payment, id: r.params.id}),
    },
    {
      path: 'products',
      name: 'schema.products',
      component: SchemaBaseTable,
      props: r => ({schema: Product, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'products/create',
      name: ['create_schema_$name', {name: '${i18n.schema.product}'}],
      component: SchemaBaseForm,
      props: r => ({schema: CreateProduct, id: r.params.id}),
    },
    {
      path: 'products/:id',
      name: ['schema_$name_details', {name: '${i18n.schema.product}'}],
      component: SchemaBaseForm,
      props: r => ({schema: Product, id: r.params.id}),
    },
    {
      path: 'services',
      name: 'schema.services',
      component: SchemaBaseTable,
      props: r => ({schema: Service, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'services/:id',
      name: ['schema_$name_details', {name: '${i18n.schema.service}'}],
      component: SchemaBaseForm,
      props: r => ({schema: Service, id: r.params.id}),
    },
    {
      path: 'coupons',
      name: 'schema.coupons',
      component: SchemaBaseTable,
      props: r => ({schema: Coupon, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'coupons/create',
      name: ['create_schema_$name', {name: '${i18n.schema.coupon}'}],
      component: SchemaBaseForm,
      props: r => ({schema: CreateCoupon, id: r.params.id}),
    },
    {
      path: 'coupons/:id',
      name: ['schema_$name_details', {name: '${i18n.schema.coupon}'}],
      component: SchemaBaseForm,
      props: r => ({schema: Coupon, id: r.params.id}),
    },
    {
      path: 'feedback-admin/create',
      name: ['create_schema_$name', {name: '${i18n.schema.feedback_admin}'}],
      component: SchemaBaseForm,
      props: {schema: CreateFeedbackAdmin},
    },
    {
      path: 'feedback-admin/:id',
      name: ['schema_$name_details', {name: '${i18n.schema.feedback_admin}'}],
      component: SchemaBaseForm,
      props: r => ({schema: FeedbackAdminToClient, id: r.params.id, readonly: true}),
    },
    {
      path: 'feedback-admin-client',
      name: 'schema.feedbacks_admin',
      component: SchemaBaseTable,
      props: r => ({schema: FeedbackAdminToClient, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'feedback-admin-caregiver',
      name: 'schema.feedbacks_admin',
      component: SchemaBaseTable,
      props: r => ({schema: FeedbackAdminToCaregiver, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'feedback-caregiver',
      name: 'schema.feedbacks_caregiver',
      component: SchemaBaseTable,
      props: r => ({schema: FeedbackCaregiver, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'feedback-caregiver/:id',
      name: ['schema_$name_details', {name: '${i18n.schema.feedback_caregiver}'}],
      component: SchemaBaseForm,
      props: r => ({schema: FeedbackCaregiver, id: r.params.id, readonly: true}),
    },
    {
      path: 'feedback-client',
      name: 'schema.feedbacks_client',
      component: SchemaBaseTable,
      props: r => ({schema: FeedbackClient, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'feedback-client/:id',
      name: ['schema_$name_details', {name: '${i18n.schema.feedback_client}'}],
      component: SchemaBaseForm,
      props: r => ({schema: FeedbackClient, id: r.params.id, readonly: true}),
    },
    {
      path: 'notifications',
      name: 'schema.notifications',
      component: SchemaBaseTable,
      props: r => ({schema: Notification, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'notifications/:id',
      name: ['schema_$name_details', {name: '${i18n.schema.notification}'}],
      component: SchemaBaseForm,
      props: r => ({schema: Notification, id: r.params.id, readonly: true}),
    },
    {
      path: 'systemnotifications',
      name: 'schema.systemnotifications',
      component: SchemaBaseTable,
      props: r => ({schema: SystemNotification, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'systemnotifications/create',
      name: ['create_schema_$name', {name: '${i18n.schema.systemnotification}'}],
      component: SchemaBaseForm,
      props: {schema: CreateSystemNotification},
    },
    {
      path: 'systemnotifications/:id',
      name: ['schema_$name_details', {name: '${i18n.schema.systemnotification}'}],
      component: SchemaBaseForm,
      props: r => ({schema: SystemNotification, id: r.params.id}),
    },
    {
      path: 'sendouts',
      name: 'schema.adminsendouts',
      component: SchemaBaseTable,
      props: r => ({schema: AdminSendouts, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'sendouts/create',
      name: 'schema.adminsendout',
      component: SchemaBaseForm,
      props: {schema: CreateMemberNotification},
    },
    {
      path: 'sendouts/:id',
      name: ['schema_$name_details', {name: '${i18n.schema.adminsendout}'}],
      component: SchemaBaseForm,
      props: r => ({schema: AdminSendouts, id: r.params.id, readonly: true}),
    },
    {
      path: 'emails',
      name: 'schema.emails',
      component: SchemaBaseTable,
      props: r => ({schema: Emails, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'emails/:id',
      name: ['schema_$name_details', {name: '${i18n.schema.email}'}],
      component: SchemaBaseForm,
      props: r => ({schema: Emails, id: r.params.id, readonly: true}),
    },
    {
      path: 'logs',
      name: 'schema.logs',
      component: SchemaBaseTable,
      props: r => ({schema: Log, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'logs/:id',
      name: ['schema_$name_details', {name: '${i18n.schema.log}'}],
      component: SchemaBaseForm,
      props: r => ({schema: Log, id: r.params.id}),
    },
    {
      path: 'contents',
      name: 'schema.contents',
      component: SchemaBaseTable,
      props: r => {
        return {
          schema: Content,
          initialFilter: {...parseFilter(r.query), ...(debug.DEBUG ? {} : {editable: true})},
        };
      },
    },
    {
      path: 'posts',
      name: 'schema.posts',
      component: SchemaBaseTable,
      props: r => ({schema: ContentPost, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'posts/create',
      name: ['create_schema_$name', {name: '${i18n.schema.post}'}],
      component: SchemaBaseForm,
      props: {schema: CreateContentPost},
    },
    {
      path: 'contents/create',
      name: ['create_schema_$name', {name: '${i18n.schema.content}'}],
      component: SchemaBaseForm,
      props: {schema: CreateContent},
    },
    /* todo: pending */
    // {
    //   path: 'contents/category/:id',
    //   name: ['schema_$name_details', {name: '${i18n.schema["content-category"]}'}],
    //   component: SchemaBaseForm,
    //   props: r => ({schema: ContentCategory, id: r.params.id}),
    // },
    {
      path: 'posts/:id',
      name: ['schema_$name_details', {name: '${i18n.schema.post}'}],
      component: SchemaBaseForm,
      props: r => ({schema: ContentPost, id: r.params.id}),
    },
    {
      path: 'contents/input_form-joinus/:id',
      name: ['schema_$name_details', {name: '${i18n.schema["content-joinus-input_form"]}'}],
      component: SchemaBaseForm,
      props: r => ({schema: ContentJoinusInputform, id: r.params.id}),
    },
    // {
    //   path: 'contents/area-content/:id',
    //   name: ['schema_$name_details', {name: '${i18n.schema["content-area-content"]}'}],
    //   component: SchemaBaseForm,
    //   props: r => ({schema: ContentAreaContent, id: r.params.id}),
    // },
    // {
    //   path: 'contents/latest_booking-purchase/:id',
    //   name: ['schema_$name_details', {name: '${i18n.schema["content-purchase-latest_booking"]}'}],
    //   component: SchemaBaseForm,
    //   props: r => ({schema: ContentPurchaseLatestbooking, id: r.params.id}),
    // },
    // {
    //   path: 'contents/new_order-purchase/:id',
    //   name: ['schema_$name_details', {name: '${i18n.schema["content-purchase-new_order"]}'}],
    //   component: SchemaBaseForm,
    //   props: r => ({schema: ContentPurchaseNeworder, id: r.params.id}),
    // },
    {
      path: 'contents/content-faq/:id',
      name: ['schema_$name_details', {name: '${i18n.schema["content-content-faq"]}'}],
      component: SchemaBaseForm,
      props: r => ({schema: ContentContentFaq, id: r.params.id}),
    },
    {
      path: 'contents/banner_top-joinus/:id',
      name: ['schema_$name_details', {name: '${i18n.schema["content-joinus-banner_top"]}'}],
      component: SchemaBaseForm,
      props: r => ({schema: ContentJoinusBannertop, id: r.params.id}),
    },
    {
      path: 'contents/our_services_page-whyus_features/:id',
      name: ['schema_$name_details', {name: '${i18n.schema["content-our_services_page-whyus_features"]}'}],
      component: SchemaBaseForm,
      props: r => ({schema: ContentOurservicespageWhyusfeatures, id: r.params.id}),
    },
    // {
    //   path: 'contents/our_services_page-overlabel/:id',
    //   name: ['schema_$name_details', {name: '${i18n.schema["content-our_services_page-overlabel"]}'}],
    //   component: SchemaBaseForm,
    //   props: r => ({schema: ContentOurservicespageOverlabel, id: r.params.id}),
    // },
    // {
    //   path: 'contents/banner_bottom-our_services_page/:id',
    //   name: ['schema_$name_details', {name: '${i18n.schema["content-our_services_page-banner_bottom"]}'}],
    //   component: SchemaBaseForm,
    //   props: r => ({schema: ContentOurservicespageBannerbottom, id: r.params.id}),
    // },
    {
      path: 'contents/download_top-our_services_page/:id',
      name: ['schema_$name_details', {name: '${i18n.schema["content-our_services_page-download_top"]}'}],
      component: SchemaBaseForm,
      props: r => ({schema: ContentOurservicespageDownloadtop, id: r.params.id}),
    },
    {
      path: 'contents/our_services_page-whyus_middle/:id',
      name: ['schema_$name_details', {name: '${i18n.schema["content-our_services_page-whyus_middle"]}'}],
      component: SchemaBaseForm,
      props: r => ({schema: ContentOurservicespageWhyusmiddle, id: r.params.id}),
    },
    {
      path: 'contents/our_services_details-our_services_page/:id',
      name: ['schema_$name_details', {name: '${i18n.schema["content-our_services_page-our_services_details"]}'}],
      component: SchemaBaseForm,
      props: r => ({schema: ContentOurservicespageOurservicesdetails, id: r.params.id}),
    },
    // {
    //   path: 'contents/aboutus/:id',
    //   name: ['schema_$name_details', {name: '${i18n.schema["content-aboutus"]}'}],
    //   component: SchemaBaseForm,
    //   props: r => ({schema: ContentAboutus, id: r.params.id}),
    // },
    {
      path: 'contents/aboutus-bridge/:id',
      name: ['schema_$name_details', {name: '${i18n.schema["content-aboutus-bridge"]}'}],
      component: SchemaBaseForm,
      props: r => ({schema: ContentAboutusBridge, id: r.params.id}),
    },
    {
      path: 'contents/aboutus-middle/:id',
      name: ['schema_$name_details', {name: '${i18n.schema["content-aboutus-middle"]}'}],
      component: SchemaBaseForm,
      props: r => ({schema: ContentAboutusMiddle, id: r.params.id}),
    },
    {
      path: 'contents/aboutus-plain_text/:id',
      name: ['schema_$name_details', {name: '${i18n.schema["content-aboutus-plain_text"]}'}],
      component: SchemaBaseForm,
      props: r => ({schema: ContentAboutusPlaintext, id: r.params.id}),
    },
    {
      path: 'contents/aboutus-tri/:id',
      name: ['schema_$name_details', {name: '${i18n.schema["content-aboutus-tri"]}'}],
      component: SchemaBaseForm,
      props: r => ({schema: ContentAboutusTri, id: r.params.id}),
    },
    {
      path: 'contents/recruitment/:id',
      name: ['schema_$name_details', {name: '${i18n.schema["content-recruitment"]}'}],
      component: SchemaBaseForm,
      props: r => ({schema: ContentRecruitment, id: r.params.id}),
    },
    // {
    //   path: 'contents/test/:id',
    //   name: ['schema_$name_details', {name: 'Test'}],
    //   component: SchemaBaseForm,
    //   props: r => ({schema: ContentTest, id: r.params.id}),
    // },
    // {
    //   path: 'contents/contact-middle/:id',
    //   name: ['schema_$name_details', {name: '${i18n.schema["content-contact-middle"]}'}],
    //   component: SchemaBaseForm,
    //   props: r => ({schema: ContentContactMiddle, id: r.params.id}),
    // },
    {
      path: 'contents/:tags/:id',
      name: ['schema_$name_details', {name: '${i18n.schema.content}'}],
      component: SchemaBaseForm,
      props: r => ({schema: ContentAny, id: r.params.id}),
    },
    {
      path: 'enquiries',
      name: 'schema.enquiries',
      component: SchemaBaseTable,
      props: r => ({schema: Enquiry, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'enquiry_questionnaires',
      name: 'schema.enquiry_questionnaires',
      component: SchemaBaseTable,
      props: r => ({schema: EnquiryQuestionnaire, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'enquiry_questionnaires1',
      name: 'schema.enquiry_questionnaires',
      component: SchemaBaseTable,
      props: r => ({schema: EnquiryQuestionnaire1, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'enquiries/questionnaire/:id',
      name: ['schema_$name_details', {name: '${i18n.schema.enquiry_questionnaire}'}],
      component: SchemaBaseForm,
      props: r => ({schema: EnquiryQuestionnaire, id: r.params.id, readonly: true}),
    },
    {
      path: 'enquiries/:id',
      name: ['schema_$name_details', {name: '${i18n.schema.enquiry}'}],
      component: SchemaBaseForm,
      props: r => ({schema: Enquiry, id: r.params.id, readonly: true}),
    },
    {
      path: 'systemconfigs',
      name: 'schema.systemconfigs',
      component: SchemaBaseTable,
      props: r => ({schema: Systemconfig, initialFilter: parseFilter(r.query)}),
    },
    {
      path: 'systemconfigs/:id',
      name: ['schema_$name_details', {name: '${i18n.schema.systemconfig}'}],
      component: SchemaBaseForm,
      props: r => ({schema: Systemconfig, id: r.params.id}),
    },
  ],
};

// let componentsMenu = {
//   path: '/components',
//   component: DashboardLayout,
//   redirect: '/components/buttons',
//   children: [
//     {
//       path: 'buttons',
//       name: 'Buttons',
//       component: Buttons,
//     },
//     {
//       path: 'grid-system',
//       name: 'Grid System',
//       component: GridSystem,
//     },
//     {
//       path: 'panels',
//       name: 'Panels',
//       component: Panels,
//     },
//     {
//       path: 'sweet-alert',
//       name: 'Sweet Alert',
//       component: SweetAlert,
//     },
//     {
//       path: 'notifications',
//       name: 'Notifications',
//       component: Notifications,
//     },
//     {
//       path: 'icons',
//       name: 'Icons',
//       component: Icons,
//     },
//     {
//       path: 'typography',
//       name: 'Typography',
//       component: Typography,
//     },
//
//   ],
// };
// let formsMenu = {
//   path: '/forms',
//   component: DashboardLayout,
//   redirect: '/forms/regular',
//   children: [
//     {
//       path: 'regular',
//       name: 'Regular Forms',
//       component: RegularForms,
//     },
//     {
//       path: 'extended',
//       name: 'Extended Forms',
//       component: ExtendedForms,
//     },
//     {
//       path: 'validation',
//       name: 'Validation Forms',
//       component: ValidationForms,
//     },
//     {
//       path: 'wizard',
//       name: 'Wizard',
//       component: Wizard,
//     },
//   ],
// };

// let tablesMenu = {
//   path: '/table-list',
//   component: DashboardLayout,
//   redirect: '/table-list/regular',
//   children: [
//     {
//       path: 'regular',
//       name: 'Regular Tables',
//       component: RegularTables,
//     },
//     {
//       path: 'extended',
//       name: 'Extended Tables',
//       component: ExtendedTables,
//     },
//     {
//       path: 'paginated',
//       name: 'Paginated Tables',
//       component: PaginatedTables,
//     }],
// };

// let mapsMenu = {
//   path: '/maps',
//   component: DashboardLayout,
//   redirect: '/maps/google',
//   children: [
//     {
//       path: 'google',
//       name: 'Google Maps',
//       component: GoogleMaps,
//     },
//     {
//       path: 'full-screen',
//       name: 'Full Screen Map',
//       component: FullScreenMap,
//     },
//     {
//       path: 'vector-map',
//       name: 'Vector Map',
//       component: VectorMaps,
//     },
//   ],
// };

// let pagesMenu = {
//   path: '/pages',
//   component: DashboardLayout,
//   redirect: '/pages/user',
//   children: [
//     {
//       path: 'user',
//       name: 'User Page',
//       component: User,
//     },
//     {
//       path: 'timeline',
//       name: 'Timeline Page',
//       component: TimeLine,
//     },
//   ],
// };

let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login,
};

// let registerPage = {
//   path: '/register',
//   name: 'Register',
//   component: Register,
// };
//
// let lockPage = {
//   path: '/lock',
//   name: 'Lock',
//   component: Lock,
// };

const routes = [
  {
    path: '/',
    name: 'menu.overview',
    // component: DashboardLayout,
    redirect: '/admin/overview',
    // children: [
    //   {
    //     path: 'calendar',
    //     name: 'Calendar',
    //     component: Calendar,
    //   },
    //   {
    //     path: 'charts',
    //     name: 'Charts',
    //     component: Charts,
    //   },
    // ],
  },
  adminMenu,
  // componentsMenu,
  // formsMenu,
  // tablesMenu,
  // mapsMenu,
  // pagesMenu,
  loginPage,
  // registerPage,
  // lockPage,
  {
    path: '/admin',
    component: DashboardLayout,
    meta: {auth: true},
    redirect: '/admin/overview',
    children: [
      {
        path: 'overview',
        name: 'menu.overview',
        component: Overview,
      },
      // {
      //   path: 'stats',
      //   name: 'Stats',
      //   component: Stats,
      // },
    ],
  },
  {
    path: '/logout',
    name: 'Logout',
    component: {
      template: '<div></div>',
      mounted() {
        this.$auth = null;
        this.$nextTick(() => {
          this.$router.replace('/');
        });
      },
    },
  },
  {path: '*', component: NotFound},
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;



// WEBPACK FOOTER //
// ./src/routes/routes.js